
import { ActivityBranch, CreateActivityBranch, UpdateActivityBranch } from '@/entities/activityBranch';
import { ActivityBranchService } from '@/services/ActivityBranchService';
import { useEffect, useState} from 'react';
export function useActivityBranch(){
  const [activityBranchs, setActivityBranchs] = useState<ActivityBranch[]>([]);
  const [searchedActivityBranch, setSearchedActivityBranch] = useState<ActivityBranch[]>([]);
  const [errorFetchActivityBranch, setErrorFetchActivityBranch] = useState(false);
  const [searchedActivityBranchError, setSearchedActivityBranchError] = useState(false);
  const [errorSaveActivityBranch, setErrorSaveActivityBranch] = useState(false);
  const [errorDeleteActivityBranch, setErrorDeleteActivityBranch] = useState(false);
  const [errorCreateActivityBranch, setErrorCreateActivityBranch] = useState(false);

  useEffect(()=>{
    const fetchActivityBranch = async ()=>{
      try{
        const response = await ActivityBranchService.getAllActivityBranch();
        if(response){
          const activityBranches = response.map((data)=>({
            id: data.id,
            name: data.name,
            contactNumber:data.contactNumber
          })).sort((a, b) => a.id - b.id);
          setActivityBranchs(activityBranches);
        }
      }catch(error){
        console.error(`Falha ao carregar os dados: ${error}`);
        setErrorFetchActivityBranch(true);
      }
    };

    fetchActivityBranch();
  }, []);

  const saveActivityBranch = async (activityBranches:UpdateActivityBranch[]) => {
    try{
      await ActivityBranchService.updateManyActivityBranch(activityBranches);
    }catch(error){
      console.error(`Falha ao atualizar os dados: ${error}`);
      setErrorSaveActivityBranch(true);
    }
  };
   
  const deleteActivitiyBranch = async (id: number) => {
    try{
      await ActivityBranchService.deleteActivityBranch(id);
    }catch(error){
      console.error(`Falha ao deletar dado: ${error}`);
      setErrorDeleteActivityBranch(true);
    }
  };

  const createActivityBranch = async (activityBranch:CreateActivityBranch) => {
    try{
      const response = ActivityBranchService.createActivityBranch(activityBranch);
    }catch(error){
      console.error(`Falha ao criar dado${error}`);
      setErrorCreateActivityBranch(true);
    }
  };

  const searchActivityBranch = async (contain:string) => {
    try{
      const response = await ActivityBranchService.searchActivityBranch(contain);
      if(response){
        const activityBranches = response.map((data)=>({
          id: data.id,
          name: data.name,
          contactNumber: data.contactNumber
        })).sort((a, b) => a.id - b.id);
        setSearchedActivityBranch(activityBranches);
      }
    }catch(error){
      console.error(`Falha ao buscar dados${error}`);
    }
  };

  return {
    searchedActivityBranch,
    activityBranchs,
    deleteActivitiyBranch,
    saveActivityBranch,
    createActivityBranch,
    searchActivityBranch
  };        
}
